function calcHeight(){
    const header = document.querySelector('#shopify-section-header header');
    const headerHeight = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    
    
    
    const announcementBar = document.querySelector('.announcement-bar__container');
    if (announcementBar){
        const announcementBarHeight = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
    } else {
        document.documentElement.style.setProperty('--announcement-bar-height', 0 + 'px');
    }
}

calcHeight();

window.addEventListener('resize', () => {
    calcHeight();
})
